<div class="container">
  <header class="row">
    <div class="col-12">
      <app-title-with-back [showButton]="stepper.currentIndex > 0 && stepper.currentIndex < 3" (backClicked)="onBack()"
        >Edición de Usuario {{ isOperative ? "Operativo" : "Corporativo" }} Fiduciaria</app-title-with-back
      >
    </div>
  </header>

  <div class="row">
    <div class="col-12">
      <uni-stepper #stepper stepperId="usersCreation">
        <uni-step label="Datos Personales">
          <div class="col-md-6 mx-auto">
            <app-personal-data-form [personalData]="newUser" (submitForm)="onSubmitPersonalData($event)"></app-personal-data-form>
          </div>
        </uni-step>

        <uni-step label="Datos de Acceso">
          <div class="col-md-6 mx-auto">
            <app-access-form-fiduciary
              [accessData]="newUser"
              (submitForm)="onSubmitAccessData($event)"
            ></app-access-form-fiduciary>
          </div>
        </uni-step>

        <uni-step label="Permisos">
          <div class="col-md-10 mx-auto">
            <permisos-nuevo-fiduciaria
              (back)="onBack()"
              [asignaciones]="newUser"
              [resetForm]="resetForm"
              (submitForm)="onSummit($event)"
            ></permisos-nuevo-fiduciaria>
          </div>
        </uni-step>

        <uni-step label="Confirmación">
          <div class="col-lg-6 col-sm-12 mx-auto">
            <app-confirmation-fiduciary [isEditing]="true" (reset)="onReset()" [newUser]="newUser"></app-confirmation-fiduciary>
          </div>
        </uni-step>
      </uni-stepper>
    </div>
  </div>
</div>
